import * as _ from 'underscore';
// this module is for global browser state that is not always mockable in tests

/**
 * Sets the window location of the browser
 *
 * @param uri
 */
export function setWindowLocation(uri: string) : void {
    window.location.assign(uri);
}

/**
 * Returns the hostname for the window
 */
export function getWindowHostname() : string {
    return window.location.hostname;
}

/**
 * Reloads the page
 */
export function reloadPage() : void {
    window.location.reload();
}
